import React from "react";

export default function StageTimer({ timeLabel }) {
  return (
    <div
      className="stage-escape-timer"
      aria-live="polite"
      aria-label={`Elapsed time ${timeLabel}`}
    >
      <span className="stage-escape-timer__icon" aria-hidden>
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      </span>
      <span className="stage-escape-timer__value">{timeLabel}</span>
    </div>
  );
}
